<template>
    <b-card class="prozess-digital-signature">
      <div>
        <div class="mb-1 d-flex">
            <div style="width: 50%;">
                <h2> {{ $t('Generate Document') }} </h2>
            </div>
            <div style="width: 50%; display: flex; justify-content: flex-end;" v-if="!generateAllRelation">
                <button id="cancel-create-button" style="margin-left: 8px; margin-right: 8px; width: 30%; min-width: 120px;" class="btn btn-primary d-flex justify-content-around align-items-center btn-secondary"
                    @click="generate()"
                    :class="{ 'icon-disabled': documentTemplates.length === 0}"
                    >
                    <span v-if="!onGenerateDocument">{{ $t('Generate and Save') }}</span>
                    <b-spinner v-else small />
                </button>

                <button id="cancel-create-button" class="btn btn-primary d-flex justify-content-around align-items-center btn-secondary"
                @click="cancelCreate()">
                    <span>{{ $t('Cancel') }}</span>
                </button>
            </div>
        </div>
        <div v-if="onTemplatesLoad" class="d-flex justify-content-center">
          <b-spinner small />
        </div>
        <div v-else>
            <div class="temp-sel" style="border-radius: 6px; padding: 12px; border: solid 1px gainsboro; margin-bottom: 6px;"
                :style="{pointerEvents: onGenerateDocument? 'none':  ''}">
                <p style="margin: 0px">{{ $t('Select Document Template') }}</p>
                <div class="d-flex">
                    <ProzessSelect
                        v-model="selectedTemplate"
                        style="width: 420px;"
                        :options="getDocumentTemplateOptions()"
                    />

                    <button id="preview-temp-button"
                        class="btn btn-primary d-flex justify-content-around align-items-center btn-secondary"
                        @click="addSelectedTemplate()"
                        style="margin-left: 8px; min-width: 100px;"
                        :disabled="selectedTemplate == null || onLoadTemplateData"
                        :class="{
                            'icon-disabled': selectedTemplate == null || onLoadTemplateData
                        }"
                        >
                        <span v-if="!onLoadTemplateData">{{ $t('Add') }}</span>
                        <b-spinner v-else small/>
                    </button>
                </div>
                <br/>
                <b-form-checkbox style="margin-left: -8px;"
                    v-model="showAllFields"
                    switch
                    inline>
                    <span style="font-size: 1rem">{{ $t('Show All Fields') }}</span>
                </b-form-checkbox>
            </div>

            <div style="margin-top: 12px; border-radius: 6px; border: solid 1px rgb(200,200,200); overflow: hidden;"  :style="{ pointerEvents: onGenerateDocument? 'none': ''}">
                <div v-for="(docTemplate, ii) of documentTemplates"  :key="`tsel-${ii}`" class="doc-panel"
                    :style="{ opacity: onGenerateDocument && generatingIdx === ii? '0.85':  onGenerateDocument?'0.4':'1',
                            color: onGenerateDocument && ii <generatingIdx ? 'green !important' : '',
                            backgroundColor:
                                onGenerateDocument && generatingIdx === ii? '' :
                                                                            onGenerateDocument?
                                                                                ii < generatingIdx ?'rgba(82, 173, 123,0.18)':'gainsboro':
                                                                                ''
                    }">
                    <div v-if="onGenerateDocument && generatingIdx === ii"
                        style="position: absolute; left: 50%; margin-top: 38px; display: flex; margin-left: -80px; margin-right: auto;" >
                        <b-spinner medium style="margin-top: 3px;"/>
                        <p style="margin:0px;margin-top: 6px; margin-left: 6px;">{{ $t('Generating Document') }}</p>
                    </div>
                    <div v-if="docTemplate!=null">
                        <div class="d-flex" style="padding: 12px;" @click="toggleOpenDocTemplate(ii)">
                            <div style="width: 100%;">
                                <p style="margin:0px;">{{ $t('Document') + ' ' + (ii+1)}}</p>
                                <p style="margin:0px; margin-bottom: 2px;">{{ docTemplate.contractTemplate.pdfFileName }}</p>
                                <h2>{{ docTemplate.contractTemplate.name }}</h2>
                                 <p v-if="docTemplate.hasCommissionModuleField && !generateAllRelation" style="margin-bottom: 0; font-size:0.96rem; color: rgb(34, 152, 89)">{{ $t('*This document template contains fields for Commission Model' )}}</p>
                            </div>
                            <button v-if=hasFieldsToShow(ii) style="width: 65px; padding: 16px; cursor: pointer; background: none; border: none; outline: none;">
                                <feather-icon v-if="docTemplate.isOpen" icon="ChevronUpIcon" class="tw-mr-1 tw-mt-1" size="10px" color="rgb(80,70,40)" />
                                <feather-icon v-else icon="ChevronDownIcon" class="tw-mr-1 tw-mt-1" size="10px" color="rgb(80,70,40)" />
                            </button>
                        </div>
                        <div v-if="docTemplate.hasCommissionModuleField && !generateAllRelation && getActiveCommissionModelSoloCompany().length > 1" class="temp-sel" style="border-radius: 6px; padding: 12px; border: solid 1px gainsboro; margin-bottom: 6px;"
                            :style="{pointerEvents: onGenerateDocument? 'none':  ''}">
                            <p style="margin: 0px">{{ $t('Select Commission Module') }}</p>
                            <div class="d-flex">
                                <ProzessSelect
                                    v-model="selectedCommissionModule"
                                    style="width: 420px;"
                                    :options="getActiveCommissionModelSoloCompany()"
                                />
                            </div>
                            <p style="margin-bottom: 0; font-size:0.96rem; color: rgb(100,100,100)">{{ $t('The selected company contains multiple active commission module.' )}}</p>
                        </div>
                        <div
                            :style="{
                                    transition: 'transform 0.2s ease',
                                    transform: docTemplate.isOpen ?  'scaleY(1)': 'scaleY(0)',
                                    transformOrigin: 'top',
                                    height: docTemplate.isOpen? '': '0px',
                                    overflow: 'hidden',
                                    }"
                            style="background-color: rgb(243,243,243);">
                            <div v-for="(pageNumber, i) of docTemplate.wizard.pages"
                                :key="`pdf-page-${i}`">
                                <div class="page-dddiv" v-if="shouldShowPage(ii, pageNumber)"
                                 style="padding: 8px 10px; border-bottom: solid 4px rgb(232,232,232);">
                                    <div class="d-flex">
                                        <p class="mb-0" style="margin-top:2px; font-size: 1.2rem;">{{ `Page ${pageNumber}` }}</p>
                                    </div>
                                    <div v-for="(pageField, i2) of docTemplate.wizard.pageFields[pageNumber]"  :key="`page-field-${i2}`">
                                        <div class="form-field-item d-flex" v-if="shouldShowField(ii, pageField)"
                                            style="margin-left: 20px; margin-bottom:8px;margin-top:6px; height: 40px; border-radius: 8px; align-items: center; padding:12px; background-color: rgba(255,255,255)">
                                            <div style="width: 30%;">
                                                    <p style="font-size: 1rem; margin: 0px">{{ pageField.acroKey }}</p>
                                                </div>
                                            <div style="width: 30%; display: flex; justify-content: center;">
                                                    <p style="font-size: 1rem; margin: 0px; background-color: gainsboro; border-radius: 6px; color: gray; padding-left: 6px; padding-right: 6px;">
                                                        {{ $t(getInputTypeLabel(docTemplate.wizard.formFieldMap[pageField.acroKey])) }}</p>
                                            </div>
                                            <div style="width: 40%;">
                                                <prozess-input style="padding-top: 18px" v-if="pageField.primary && docTemplate.wizard.formFieldMap[pageField.acroKey]?.type === 'manual'"
                                                    v-model="docTemplate.overrideInputs[pageField.acroKey]"/>
                                                    <p style="padding-top: 10px; color: gray;" v-if="pageField.primary && docTemplate.wizard.formFieldMap[pageField.acroKey]?.type === 'map'">{{ getMappingLabel(docTemplate, pageField.acroKey) }}</p>
                                                    <p v-if="!pageField.primary" style="width: fit-content; padding:2px; padding-left: 6px; padding-right: 6px; margin-top:14px; border-radius: 6px;font-size: 0.9rem; font-weight: 500; color:white ; background-color: lightgray;">
                                                        <span>{{ $t('Mapped on Page ') }}</span>
                                                        <span>{{ pageField.primaryPage }}</span>
                                                    </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="background-color: rgba(0, 0, 0,0.025); padding: 12px;  border-top: solid 1px rgb(235,235,235);">
                        <div class="d-flex">
                            <div style="width: 100%;">
                                <b-form-checkbox inline v-model="docTemplate.overrideName">
                                    {{ $t('Override Document Name')}}
                                </b-form-checkbox>
                            </div>
                             <button v-if="!onGenerateDocument" class="del-temp-btn" id="cancel-create-button" style="margin-top:-6px; width: 50px;border-radius: 6px;  border: none;padding: 4px 6px; height: 28px;"
                                @click="removeDocTemp(ii)">
                                <feather-icon icon="Trash2Icon" size="8px" color="white"/>
                                <!-- <span>{{ $t('Remove') }}</span> -->
                            </button>
                        </div>
                        <prozess-input v-if="docTemplate.overrideName" v-model="docTemplate.documentName"/>
                    </div>
                    <div v-if="documentTemplates.length>1 && ii<documentTemplates.length-1" style="border-bottom: solid 4px rgb(220,220,220);"></div>
                </div>
            </div>
            <div :class="{'company-sel-disabled' : documentTemplates.length === 0}">
                <div style="padding: 12px; border-radius: 6px; padding: 12px; border: solid 1px gainsboro; margin-top: 6px;">
                    <b-form-group style="margin-bottom: 0">
                        <b-form-radio v-model="generationType" name="multi-gen"  value="multi-gen" class="mb-1">
                            <p style="font-size: 1.2rem; margin-bottom:0">{{ $t('Individual Generation') }}</p>
                            <p style="margin-bottom:0; font-size: 0.9rem;">{{ $t('Generate the document/s for each selected company') }}</p>
                        </b-form-radio>
                        <b-form-radio v-model="generationType" name="parent-gen"  value="parent-gen" >
                            <p style="font-size: 1.2rem; margin-bottom:0">{{ $t('Parent Company Only') }}</p>
                            <p style="margin-bottom:0; font-size: 0.9rem">{{ $t('Generate document/s for the parent company only') }}</p>
                            <p style="margin-bottom:0; font-size: 0.9rem">{{ $t('The selected subsidiary companies will have a link to parent document') }}</p>
                        </b-form-radio>
                    </b-form-group>
                </div>
                <div style="padding: 12px; border-radius: 6px; padding: 12px; border: solid 1px gainsboro; margin-top: 6px;" v-if="subsidiaryList">
                    <p class="mb-0" style="margin-top: 12px;">{{ $t('Subsidiary Company Select') }}</p>
                    <b-form-checkbox inline  style="margin-top: -12px; cursor: pointer"  v-model="selectAllSub"   :disabled="documentTemplates.length === 0">
                        {{ this.$t('Select All') }}
                    </b-form-checkbox>
                    <div class="comp-opt" v-for="(company, i) in subsidiaryList" :key="`company-select-${i}`">
                        <b-form-checkbox
                            inline
                            style="margin-top: -12px; cursor: pointer"
                            v-model="company.selected"
                            :disabled="documentTemplates.length === 0"
                        >
                        {{ company.name }}
                        </b-form-checkbox>
                    </div>
                </div>
            </div>

            <div v-if="documentTemplates.length > 1" style="padding: 12px; margin-top: 10px; border-radius: 8px; background-color: rgb(242,242,242);">
                <h4>{{ $t('Reminder:') }}</h4>
                <p style="margin:0px">{{ $t('These documents will be grouped and will be part of a single e-signing.') }}</p>
            </div>
        </div>
        <div style="width: 100%; margin-top: 18px;display: flex; justify-content: flex-end;" v-if="generateAllRelation">
                <button id="cancel-create-button" style="margin-left: 8px; margin-right: 8px; width: 30%; min-width: 120px;" class="btn btn-primary d-flex justify-content-around align-items-center btn-secondary"
                    @click="generate()"
                    :class="{ 'icon-disabled': documentTemplates.length === 0}"
                    >
                    <span v-if="!onGenerateDocument">{{ $t('Generate and Save') }}</span>
                    <b-spinner v-else small />
                </button>

                <button id="cancel-create-button" class="btn btn-primary d-flex justify-content-around align-items-center btn-secondary"
                @click="cancelCreate()">
                    <span>{{ $t('Cancel') }}</span>
                </button>
            </div>
      </div>
    </b-card>
  </template>

  <script>
  import contractTemplateService from '@/services/contractTemplate'
  import moment from 'moment'
  import { GenericTabs, Schema } from '@/constants/app'

  export default {
    props: {
        cancelCreate: {
            type: Function,
            required: true,
        },
        createComplete: {
            type: Function,
            required: true,
        },
        generateAllRelation: {
            type: Boolean,
            required: true,
        },
        leafMap: {
            type: Object,
            required: false,
        },
    },
    data() {
      return {
        onTemplatesLoad: false,
        onLoadTemplateData: false,
        selectedTemplate: null,
        selectedCommissionModule: null,
        subsidiaryCommissionModule: {},
        documentTemplateOptions: [],
        contractTemplate: null,
        overrideName: false,
        documentName: '',
        onGenerateDocument: false,
        documentTemplates: [],
        showAllFields: false,
        generatingIdx: 0,
        docGroupUuid: null,
        selectAllSub: false,
        subsidiaryList: null,
        parentOnly: false,
        generationType: 'parent-gen',
        companyCommissions: [],
      }
    },
    created() {
      this.getInitialData()
    },

  watch: {
    selectAllSub: {
      handler(value) {
        // Fires immediately on create, before getTemplates has built the list — and stays null
        // for good on the screens that generate without a subsidiary picker.
        if (!this.subsidiaryList) return
        this.subsidiaryList.forEach(s => {
            s.selected = value
        })
      },

      deep: true,
      immediate: true,
    },
    },
    methods: {
        getDocumentTemplateOptions() {
            const usedTemplateIds = this.documentTemplates.map(dt => dt.contractTemplate.id)
            return this.documentTemplateOptions.filter(dto => !usedTemplateIds.includes(dto.key))
        },
        getActiveCommissionModelSoloCompany() {
            const compComm = this.companyCommissions[this.$route.params.id]
            const commSel = compComm.map(cc => ({
                key: cc.id,
                label: cc.modelName,
                moduleId: cc.moduleId,
            }))
            return commSel
        },
        removeDocTemp(docTemplateIndex) {
            this.documentTemplates.splice(docTemplateIndex, 1)
        },
        hasFieldsToShow(docTemplateIndex) {
            if (this.showAllFields) return true
            const requireInput = ['manual']
            const allFFtypes = Object.values(this.documentTemplates[docTemplateIndex].wizard.formFieldMap).map(ff => ff.type)
            const joinArr = [requireInput, allFFtypes]
            return joinArr.reduce((p, c) => p.filter(e => c.includes(e))).length > 0
        },
        shouldShowField(docTemplateIndex, pField) {
            if (this.showAllFields) return true

            const requireInput = ['manual']
            const formFieldM = this.documentTemplates[docTemplateIndex].wizard.formFieldMap

            return requireInput.includes(formFieldM[pField.acroKey]?.type)
        },
         shouldShowPage(docTemplateIndex, pageNum) {
            if (this.showAllFields) return true

            const requireInput = ['manual']
            const pageFields = JSON.parse(JSON.stringify(this.documentTemplates[docTemplateIndex].wizard.pageFields[pageNum]))
            const formFieldM = JSON.parse(JSON.stringify(this.documentTemplates[docTemplateIndex].wizard.formFieldMap))

            let requiresInput = 0
            pageFields.forEach(pF => {
                const acroKey = pF.acroKey
                if (requireInput.includes(formFieldM[acroKey]?.type)) {
                    requiresInput++
                }
            })
            return requiresInput > 0
        },
        countManual(docTemplateIndex, pageNum) {
            const requireInput = ['manual']
            const pageFields = this.documentTemplates[docTemplateIndex].wizard.pageFields[pageNum]
            const formFieldM = this.documentTemplates[docTemplateIndex].wizard.formFieldMap
            let requiresInput = 0
            pageFields.forEach(pF => {
                const acroKey = pF.acroKey
                if (requireInput.includes(formFieldM[acroKey].type)) {
                    requiresInput++
                }
            })
            return requiresInput
        },
        getMappingLabel(docTemplate, acroKey) {
            return docTemplate.wizard.formFieldMap[acroKey].schema.concat('.')
                            .concat(docTemplate.wizard.formFieldMap[acroKey].key).concat('.')
                            .concat(docTemplate.wizard.formFieldMap[acroKey].fieldKey)
        },
        getInputTypeLabel(ff) {
            let label = ''
            switch (ff?.type) {
                case 'map': label = 'Mapping'; break
                case 'manual': label = 'Manual Input'; break
                case 'auto': label = 'Auto-set'; break
                case 'page_module':
                    label = 'Page Module'
                    switch (ff.key) {
                        case 'commission_model': label = 'Provisjonsmodell'; break
                        default: break
                    }
                break
                default: return ''
            }
            return label
        },
        async addSelectedTemplate() {
            this.onLoadTemplateData = true
            const templateId = this.selectedTemplate.key
            const { response } = await this.$async(contractTemplateService.getTemplateById(templateId))
            const wizardd = {
                pageFields: response.data.pageFields,
                pages: Object.keys(response.data.pageFields),
                formFieldMap: response.data.formFieldMap,
            }
            const contractTemplatee = response.data.template.contractTemplate
            const commissionModuleFields = Object.values(wizardd.formFieldMap).filter(ff => ff.type === 'page_module' && ff.key === 'commission_model')
            console.log('y1')
            const newTemplate = {
                overrideInputs: {},
                contractTemplate: contractTemplatee,
                wizard: wizardd,
                isOpen: this.documentTemplates.length === 0,
                overrideName: false,
                hasCommissionModuleField: commissionModuleFields.length > 0,
                documentName: `${contractTemplatee.name.replace(/\s+/g, '-').toLowerCase()}-${moment(new Date()).format('YYYY-MM-DD')}`,
            }
            console.log('y2', newTemplate)
            this.documentTemplates.push(newTemplate)
            console.log('y3')
            this.onLoadTemplateData = false
            this.selectedTemplate = null
        },
        async generate() {
            this.onGenerateDocument = true
            this.generatingIdx = 0
            if (this.documentTemplates.length > 0) {
                this.docGroupUuid = this.$uuidv4()
            }
            await this.generateDocument(this.documentTemplates[this.generatingIdx])
            // this.documentTemplates.forEach(async dT => this.generateDocument(dT))
        },
        async generateDocument(documentTemplate) {
                const generateDocumentRequest = {
                    companyId: this.$route.params.id,
                    templateId: documentTemplate.contractTemplate.id,
                    generateAllRelation: this.generateAllRelation,
                    documentName: documentTemplate.overrideName ? documentTemplate.documentName : `${documentTemplate.contractTemplate.name.replace(/\s+/g, '-').toLowerCase()}-${moment(new Date()).format('YYYY-MM-DD')}`,
                    overrideInputs: JSON.parse(JSON.stringify(documentTemplate.overrideInputs)),
                    parentOnly: this.generationType === 'parent-gen',
                    fullSubsidiaryList: this.subsidiaryList
                      ? this.subsidiaryList.map(s => s.uuid)
                      : [],
                }

                if (this.subsidiaryList) {
                    const finalSubsidiaryList = this.subsidiaryList.filter(s => s.selected).map(s => s.uuid)
                    generateDocumentRequest.subsidiaryList = finalSubsidiaryList
                }
                if (this.selectedCommissionModule != null) {
                    generateDocumentRequest.commissionModules = {}
                    generateDocumentRequest.commissionModules[this.$route.params.id] = this.selectedCommissionModule.key
                }
                // No destructuring here: the callback below returns nothing, so awaiting the
                // chain yields undefined and pulling `response` off it threw on every generation —
                // after the document had already been created and linked, so it read as a failure
                // that wasn't one. The value was never used.
                await this.$async(contractTemplateService.generate(generateDocumentRequest)).then(async res => {
                    const docLinkReqRes = res.response.data
                    docLinkReqRes.docGroupUuid = this.docGroupUuid
                    const docUuid = await contractTemplateService.linkDocument(docLinkReqRes)
                    this.generatingIdx++
                    if (this.generatingIdx < this.documentTemplates.length) {
                        this.generateDocument(this.documentTemplates[this.generatingIdx])
                    } else {
                        this.onGenerateDocument = false
                        this.createComplete()
                    }
                })
        },
      async getInitialData() {
        await this.getTemplates()
        await this.getActiveCommissionModels()
      },
      async getActiveCommissionModels() {
        const companyIds = [this.$route.params.id]
        const { response } = await this.$async(contractTemplateService.getActiveCommissionModels(companyIds))
        this.companyCommissions = response.data.companyCommissions
        console.log('companyCommissions', this.companyCommissions)
      },
      async getTemplates() {
        this.onTemplatesLoad = true
        const { response } = await this.$async(contractTemplateService.getAll())
        // if (this.generateAllRelation) {
        if (this.leafMap) {
            this.subsidiaryList = []
            Object.keys(this.leafMap).forEach(l => {
                this.subsidiaryList.push({
                    uuid: l,
                    name: this.leafMap[l],
                    selected: false,
                })
            })
        }
        this.documentTemplateOptions =
            response.data.pageItems.map(t => ({
                        key: t.id,
                        label: t.name,
                        documentName: `${t.name.replace(/\s+/g, '-').toLowerCase()}-${moment(new Date()).format('YYYY-MM-DD')}`,
            }))
        this.onTemplatesLoad = false
        },
        toggleOpenDocTemplate(inde) {
            if (!this.hasFieldsToShow(inde)) return
            if (this.documentTemplates[inde].isOpen) {
                this.documentTemplates[inde].isOpen = false
            } else {
                this.documentTemplates.forEach((d, iii) => {
                    this.documentTemplates[iii].isOpen = false
                })
                this.documentTemplates[inde].isOpen = true
            }
        },
    },
  }
  </script>

  <style lang="scss">
  @import '@/assets/scss/variables/_variables.scss';
  @import '@/assets/scss/master-variables.scss';
  .doc-panel:hover{
    background-color: rgb(251, 251, 251);
    transition: 0.2s;
  }
  .del-temp-btn{
    outline: none;
    transition: 0.2s;
    background-color: rgb(180,180,180);
  }
  .del-temp-btn:hover{
    background-color:rgb(222, 75, 57);
  }
  .company-sel-disabled {
    pointer-events: none;
    opacity: 0.7;
  }
  </style>
